import type { RaspadinhaParticipant } from '@/types/raspadinha-campaign'

export const MOCK_RASPADINHA_PARTICIPANTS_BY_CAMPAIGN_ID: Readonly<
  Record<number, RaspadinhaParticipant[]>
> = {
  1: [
    {
      id: 'part-1-ana',
      name: 'Ana Silva',
      document: '123.456.789-00',
      email: 'ana.silva@email.com',
      phone: '(11) 98765-4321',
      participated_at: '2026-01-15T14:22:00.000Z',
      tickets_count: 3,
    },
    {
      id: 'part-1-bruno',
      name: 'Bruno Costa',
      document: '987.654.321-00',
      email: 'bruno.costa@email.com',
      phone: '(21) 99876-5432',
      participated_at: '2026-01-18T09:45:00.000Z',
      tickets_count: 5,
    },
    {
      id: 'part-1-carla',
      name: 'Carla Mendes',
      document: '111.222.333-44',
      email: 'carla.mendes@email.com',
      phone: '(31) 97654-3210',
      participated_at: '2026-01-20T16:10:00.000Z',
      tickets_count: 2,
    },
    {
      id: 'part-1-diego',
      name: 'Felipe Rocha',
      document: '222.333.444-55',
      email: 'felipe.rocha@email.com',
      phone: '(41) 96543-2109',
      participated_at: '2026-01-22T11:30:00.000Z',
      tickets_count: 4,
    },
    {
      id: 'part-1-elena',
      name: 'Elena Souza',
      document: '333.444.555-66',
      email: 'elena.souza@email.com',
      phone: '(51) 95432-1098',
      participated_at: '2026-01-25T19:05:00.000Z',
      tickets_count: 1,
    },
    {
      id: 'part-1-gustavo',
      name: 'Gustavo Lima',
      document: '444.555.666-77',
      email: 'gustavo.lima@email.com',
      phone: '(61) 94321-0987',
      participated_at: '2026-02-02T08:15:00.000Z',
      tickets_count: 6,
    },
  ],
  2: [
    {
      id: 'part-2-diego',
      name: 'Diego Alves',
      document: '555.666.777-88',
      email: 'diego.alves@email.com',
      phone: '(11) 91234-5678',
      participated_at: '2026-02-10T20:00:00.000Z',
      tickets_count: 2,
    },
    {
      id: 'part-2-helena',
      name: 'Helena Martins',
      document: '666.777.888-99',
      email: 'helena.martins@email.com',
      phone: '(11) 92345-6789',
      participated_at: '2026-02-11T10:20:00.000Z',
      tickets_count: 3,
    },
    {
      id: 'part-2-igor',
      name: 'Igor Pires',
      document: '777.888.999-00',
      email: 'igor.pires@email.com',
      phone: '(11) 93456-7890',
      participated_at: '2026-02-12T15:40:00.000Z',
      tickets_count: 1,
    },
  ],
}

export function getDefaultParticipantsForCampaign(campaignId: number): RaspadinhaParticipant[] {
  const participants = MOCK_RASPADINHA_PARTICIPANTS_BY_CAMPAIGN_ID[campaignId]
  if (!participants) return []

  return participants.map((participant) => ({ ...participant }))
}
